import { assert } from '@ember/debug';
import EmberObject from '@ember/object';

import { browserHistory } from 'register-partners-js/react/history';

type UpdateCallback = (url: string) => void;

export default class SharedHistoryLocation extends EmberObject {
  // oxlint-disable-next-line no-empty-function
  updateCallback: UpdateCallback = function () {};
  declare rootURL: string;
  _previousURL?: string;

  private history = browserHistory;

  init(): void {
    super.init();

    let { rootURL } = this;
    assert(
      'rootURL must end with a trailing forward slash e.g. "/app/"',
      rootURL.at(rootURL.length - 1) === '/'
    );
  }

  fullPath(): string {
    return this.history.location.pathname + this.history.location.search;
  }

  getURL(): string {
    const fullPath = this.fullPath();
    return this._stripRootURL(fullPath);
  }

  setURL(path: string): void {
    const formattedPath = this.formatURL(path);
    const currentPath = this.fullPath();
    if (currentPath !== formattedPath) {
      this.history.push(formattedPath);
    }
  }

  replaceURL(path: string): void {
    const formattedPath = this.formatURL(path);
    const currentPath = this.fullPath();
    if (currentPath !== formattedPath) {
      this.history.replace(formattedPath);
    }
  }

  onUpdateURL(callback: UpdateCallback): void {
    this.updateCallback = callback;
  }

  handleURL(url: string): void {
    this.setURL(url); // Set and push to history
    this.updateCallback(url);
  }

  formatURL(url: string): string {
    let { rootURL } = this;
    if (url !== '') {
      rootURL = rootURL.replace(/\/$/, '');
    }
    return `${rootURL}${url}`;
  }

  private _stripRootURL(fullPath: string): string {
    let { rootURL } = this;
    rootURL = rootURL.replace(/\/$/, '');
    return fullPath.replace(new RegExp(`^${rootURL}(?=/|\\?|$)`), '') || '/';
  }

  get path(): string {
    return this.getURL();
  }
}

SharedHistoryLocation.reopen({
  rootURL: '/',
});
